// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YdS0","rootNoMargin":"styles_rootNoMargin__3GYo8"};